import React from 'react';
import {Formik, Field, Form} from 'formik';
import {TextField, Loading} from 'components/form';
import {required, validationWrapper, number} from 'lib/formValidations';
import {transformTranslateFromValues, transformTranslateServerValues} from 'lib/helpers';
import Modal from 'components/Modal'
import {TextArea, Select} from 'components/form';
import {GalleryField} from 'components/form';
import {useCore} from 'store/core'
// components

export default function Edit(props) {

    const core = useCore();
    const {show, item} = props
    return (
        <>
            <Modal show={props.show} handleClose={props.close} title={props.title}>
                <Formik
                    initialValues={{...transformTranslateServerValues(item)}}
                    onSubmit={async (values, {setSubmitting}) => {
                        await props.submit(transformTranslateFromValues(values), item.id);
                        props.close();
                        setSubmitting(false);
                    }}
                    enableReinitialize
                >

                    {({isSubmitting, dirty}) => (
                        <Form>
                            <div className="modal-body gap-y-3">
                                <div className="intro-x grid md:grid-cols-2 md:gap-3">
                                    {!core.genresLoad ? <Field
                                        label="والد"
                                        name="parent_id"
                                        component={Select}
                                        options={[{value: 0, label: "بدون والد"}, ...core.genres] || []}
                                        
                                    /> : <Loading/>
                                    }
                                    <Field
                                        placeholder="نام"
                                        label="نام :"
                                        name="name"
                                        component={TextField}
                                        validate={(value) => validationWrapper(value, required)}
                                    />
                                    <Field
                                        label="نام انگلیسی :"
                                        placeholder="name"
                                        name="_en*name*text"
                                        component={TextField}
                                    />
                                    <Field
                                        label="توضیحات"
                                        name="desc"
                                        component={TextArea}
                                    />
                                    <Field
                                        label="description"
                                        name="_en*desc*text"
                                        component={TextArea}
                                    />
                                    <Field
                                        label="تصویر"
                                        name="media_id"
                                        dataType="id"
                                        component={GalleryField}
                                    />
                                    <Field
                                        label="Image"
                                        name="_en*media_id*media"
                                        dataType="id"
                                        component={GalleryField}
                                    />
                                </div>
                            </div>

                            <div className="modal-footer text-right">
                                <button className="btn btn-primary w-20" type="submit"
                                        disabled={!!(isSubmitting || !dirty)}> {isSubmitting ?
                                    <Loading/> : 'ذخیره'}</button>
                                <button type="button"
                                        disabled={isSubmitting}
                                        onClick={props.close} className="btn btn-outline-secondary w-20 mr-1">انصراف
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal>
        </>
    );
}
